import { SalesItem } from "@testout/testout-commerce/models/commerce/SalesItem";

export const groupSiteLicenseSubItems = (items: SalesItem[]) => {
    // Since we are now getting the deal line items from HubSpot in the correct order, we will assume
    // that the zero amount sub-items have been placed under the correct site license by the Sales Admins
    let lastLicense = -1;
    for (var i = 0; i < items.length; i++) {
        // If this is a site/group license, assign it as the parent to any zero-amount line items under it
        if (items[i].productNumber.toString() === 'TOSL22XLDL10' ||
            items[i].productNumber.toString() === 'TOSL22XLOL10' ||
            items[i].productNumber.toString() === 'TOSL19XLOP10' ||
            items[i].productNumber.toString() === 'TOSL15XLIT10' ||
            items[i].productNumber.toString() === 'TOBU22OLAG10') {
            lastLicense = i;
            let sequence = 1;
            items[i].showBundle = true;
            for (var j = i + 1; j < items.length; j++) {
                if (items[j].unitPrice !== 0)
                    break;
                items[j].parentItemId = items[i].itemId;
                items[j].sequence = sequence++;
            }
            i = j - 1; // Skip these zero-priced items as we look for any other site licenses in the deal
        }
    }
    if (lastLicense === -1)
        return;

    // If there are any remaining unassigned zero-priced sub-items, assign them to the last group license on the order
    for (var item of items) {
        if (item.unitPrice === 0 && !item.parentItemId)
            item.parentItemId = items[lastLicense].itemId;
    }
}
